import React, { useEffect, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { Table, TableContainer } from "components";

import * as table from "./tableColumns";

export const PaymentMethodsTable = ({
	loading,
	userId,
	data,
	setFetchData,
	fetchData,
	filters,
	removePaymentMethod,
	updatePaymentMethod,
	meta,
}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (filters !== fetchData.filters)
			setFetchData({ ...fetchData, page: 0, filters });
	}, [fetchData, filters, setFetchData]);

	const initialState = useMemo(
		() => ({
			sortBy: [fetchData.sortBy],
			pageIndex: fetchData.page,
		}),
		[fetchData],
	);

	const handlePageChange = useCallback(
		({ pageIndex }) => {
			if (pageIndex !== fetchData.page)
				setFetchData({ ...fetchData, page: pageIndex });
		},
		[fetchData, setFetchData],
	);

	const handleSortChange = useCallback(
		({ sortBy }) => {
			setFetchData({ ...fetchData, sortBy: sortBy[0] });
		},
		[fetchData, setFetchData],
	);

	const columns = [
		table.paymentTypeColumn(),
		table.paymentInformationColumn(),
		table.actionColumn({
			removePaymentMethod,
			updatePaymentMethod,
			dispatch,
			userId,
			loading,
		}),
	];

	return (
		<TableContainer className="mt-0">
			<Table
				columns={columns}
				meta={meta}
				data={data}
				handlePageChange={handlePageChange}
				handleSortChange={handleSortChange}
				initialState={initialState}
				stickyFooter
				stickyHeader
				compact
				minWidth={"100%"}
			/>
		</TableContainer>
	);
};
